<section class="matchday-outer">
    <!--page starts-->
    <section class="page-wrapper matchday-section margin-top-152">
        <div class="container">
             <div class="matchday-detail">
                <div class="titel-box">
					<h2 class="titel-name">SIGN UP FOR FREE ENTRY</h2>
				</div>
                <div class="matchday-top-detail">
                    <div class="matchday-top-content">
                        <p>In preparation for the Royal London Cup season, Leicestershire County Cricket Club will host a 50 over Intra-squad match on Tuesday 20th July with free entry available for all fans.</p>
                        <p>The fixture will see Team Ackermann v Team Parkinson take place at the Uptonsteel County Ground. </p>
                        <p>The club are providing free entry to all fans, perfect for the summer holidays and a chance to win a 2022 Club Membership. </p>
                        <h3>To gain entry to the ground, simply complete the form below and you will be put into the draw to win the 2022 Club Membership. </h3>
                        
                    </div>
                    <http-message types="success" [data]="attendanceSuccess" class="err-msg-block"></http-message>
                    <http-message [type]="'error'" [data]="attendanceError" *ngIf="attendanceError" class="err-msg-block"></http-message>
                    <form class="matchday-top-form" #attendanceForm="ngForm" (ngSubmit)="addAttendance(attendanceForm)" [ngClass]="{ hidden: attendanceSuccess }">
                       
                        <h4>CONTACT INFORMATION</h4>
                        <div class="matchday-top">
                            <div>
                               
                                
                                <div class="matchday-top-input-box half">
                                    <div class="custom-select" class="input-style">
                                        
                                        <select id="select_match" (change)="selectmatch()">
                                          <option value="">Select Title</option>
                                          <option value="{{match?.free_entry_form_title_id}}" *ngFor="let match of titleList?.data">{{match?.title}}</option>
                                          <!-- <option value="1">WHICH FIXTURE ARE YOU ATTENDING</option>
                                          <option value="2">WHICH FIXTURE ARE YOU ATTENDING</option> -->
                                        </select>
                                       
                                    </div>
                                    <div class="invalid-feedback  attnderror" id="select_match-msg">Title is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="matchday-outer-inner">
                            <div class="matchday-center">
                                <!-- <div class="matchday-center-attendee">
                                    <p>ATTENDEE  01</p>
                                </div> -->
                                <div class="matchday-center-add-attendee">
                                    <a (click)="addcol()">ADD Attendee</a>
                                </div>
                            </div>
                            <div class="matchday-bottom">
                                <div>
                                    <div class="bottom-main"> 
                                        <div class="matchday-bottom-inner">
                                            <div class="matchday-center-attendee full ">
                                                <p>ATTENDEE  1</p>
                                            </div>
                                            <div class="matchday-top-input-box half mr mb">
                                                <input type="text" placeholder="First Name" id="firstname1" class="input-style firstname">
                                                <div class="invalid-feedback  attnderror" id="firstname1-msg">First name is required</div>
                                            </div>
                                            <div class="matchday-top-input-box half mb">
                                                <input type="text" placeholder="Last Name" id="lastname1" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="lastname1-msg">Last name is required</div>
                                            </div>
                                            <div class="matchday-top-input-box half mr mb">
                                                <input type="number" placeholder="Mobile Number" id="mobilenumber1" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="mobilenumber1-msg">Mobile Number is required</div>
                                                <div class="invalid-feedback  attnderror" id="mobilenumber1-validmsg">Please enter minimum 10 digit Mobile Number</div>
                                            </div>
                                            <div class="matchday-top-input-box half mb">
                                                <input type="email" placeholder="Email Address" id="emailaddress1" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="emailaddress1-msg">Email is required</div>
                                                <div class="invalid-feedback  attnderror" id="emailaddress1-validmsg">Please enter valid email</div>
                                                <!-- <div class="custom-select" class="input-style">
                                                    <select>
                                                    <option value="0">Email Address</option>
                                                    </select>
                                                </div> -->
                                            </div>
                                            <div class="matchday-top-input-box full mb">
                                                <input type="text" id="address1" placeholder="Address" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="address1-msg">Address is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="matchday-bottom-content full">
                                        <p>By completing this form, you will be allowed free entry to the Uptonsteel County Ground on Tuesday 20 July for the intra-squad match. You will also be entered into a draw to be in with a chance of winning a 2022 Club Membership. </p>
                                    </div>
                                    <div class="matchday-bottom-check-box full">
                                        <label class="container">Check this box if you’d like to subscribe to the club’s marketing list to hear about exclusive offers, tickets, membership and more. 
                                            <input type="checkbox" id="attendencecheck">
                                            <span class="checkmark"></span>
                                        </label>
                                        <div class="invalid-feedback  attnderror" id="attendencecheck-msg">Check box is required</div>
                                    </div>
                                    <div class="matchday-bottom-btn full">
                                        <button type="submit">SUBMIT FORM</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
             </div>   
        </div>
    </section><!-- page ends-->
</section>